export const GLOBAL_TYPES = {
  LOGIN_USER: "LOGIN_USER",
  ALERT: "ALERT",
  THEME: "THEME",
};
